import React, { useState } from "react"
import { Box, Typography, MenuItem, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { ManageMeetingDisplayDialog } from "./ManageMeetingDisplayDialog"
import { tailwindPalette } from "../../../../../theme/tailwindPalette"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { UserMeetingsReceipt } from "../../../../../nonAdminUser/reports/MeetingsReceipt/UserMeetingsReceipt"
import { HoverActionMenu } from "../../../../../../shared/components/table/HoverActionMenu"
import { MeetingDetailsOrder } from "../../meetings/meetingTypes"
import { ServiceCenterBooking } from "../../serviceCenterHomeTypes"

const useStyles = makeStyles()(() => ({
    header: {
        display: "flex",
        alignItems: "start",
        justifyContent: "space-between",
    },
    title: {
        fontWeight: "bold",
        fontSize: "1.5rem",
    },
    orderId: {
        verticalAlign: "baseline",
        color: tailwindPalette.slate[500],
        marginLeft: "0.5rem",
    },
    actionButton: {
        width: "2rem",
        height: "2rem",
        color: "black",
        borderRadius: "0.75rem",
        border: `1px solid ${tailwindPalette.slate["300"]}`,
    },
}))

type MeetingHeaderProps = {
    orderId?: number
    meetingData?: MeetingDetailsOrder
    meetings?: ServiceCenterBooking[]
}

export const MeetingHeader: React.FC<MeetingHeaderProps> = ({ meetingData, meetings, orderId }) => {
    const { classes } = useStyles()
    const meetingName = meetingData?.meetingDetails.meetingName
    const meetingId = meetingData?.id

    const [showReceiptModal, setShowReceiptModal] = useState(false)
    const [isManageMeetingOpen, setMeetingOpen] = useState(false)

    return (
        <Box className={classes.header}>
            <Box>
                <Typography variant="h5" component="h1" className={classes.title}>
                    {meetingName}
                    <Typography component="span" className={classes.orderId}>
                        #{orderId}
                    </Typography>
                </Typography>
            </Box>
            <Stack direction="row" spacing=".5rem">
                <HoverActionMenu iconButtonClassName={classes.actionButton}>
                    {(closeMenu) => [
                        <MenuItem
                            key="manage"
                            onClick={() => {
                                setMeetingOpen(true)
                                closeMenu()
                            }}
                        >
                            <LocalizedStrict id="service-center-reports-dashboard-meetings-drawer-manage-meeting-dropdown-item-manage-meeting-display">
                                <>Manage meeting display</>
                            </LocalizedStrict>
                        </MenuItem>,
                        <MenuItem
                            key="receipt"
                            onClick={() => {
                                setShowReceiptModal(true)
                                closeMenu()
                            }}
                        >
                            Show receipt
                        </MenuItem>,
                    ]}
                </HoverActionMenu>
            </Stack>

            <ManageMeetingDisplayDialog
                isOpen={isManageMeetingOpen}
                orderId={orderId}
                meetingName={meetingName}
                handleClose={() => setMeetingOpen(false)}
            />

            {showReceiptModal && meetingData && (
                <UserMeetingsReceipt
                    id={meetingId}
                    open={showReceiptModal}
                    meetings={meetings}
                    onClose={() => setShowReceiptModal(false)}
                />
            )}
        </Box>
    )
}
